<div class="pill" (click)="onPillClick()">
  {{ value.displayName || value.documentName }}
  <span #extModRef class="external-mod-warning" *ngIf="value?.externallyModified">
    <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
    <dx-tooltip [target]="extModRef" showEvent="mouseenter" hideEvent="mouseleave" position="top">
      <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
    </dx-tooltip>
  </span>
</div>
